export const isValidField = (value: unknown) => {
  if (value === undefined || value === null) return false;
  if (typeof value === "string" && value.trim() === "") return false;
  if (typeof value === "boolean") return true;

  return true;
};

export const timeIsSameOrAfter = (start?: string, end?: string) => {
  if (!start || !end) return true;

  const startTime = `0001-01-01T${start}`;
  const endTime = `0001-01-01T${end}`;

  if (validateDate(startTime) && validateDate(endTime))
    return new Date(startTime) < new Date(endTime);

  return false;
};

export const validateDate = (date: string) => !isNaN(Date.parse(date));

export const validateDateByLang = (text: string, lang: string) => {
  let day, month, year;
  if (["pt", "es"].includes(lang)) {
    [day, month, year] = text.split("/");
  } else {
    [month, day, year] = text.split("/");
  }

  return validateDate(`${year}-${month}-${day}`);
};

export const validateURL = (text: string) => {
  const inputElement = document.createElement("input");
  inputElement.type = "url";
  inputElement.value = text;

  return inputElement.checkValidity();
};
